import { Component } from '@angular/core';

@Component({
  selector: 'terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['../terms-and-privacy-policy-styles.scss'],
  host: { class: 'ht-terms-and-conditions' }
})
export class TermsAndConditionsComponent {}
